import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as UISelectors } from 'data/ui'
import { selectors as OrganizationSelectors } from 'data/organizations'
import { getSavedPanelWidth } from 'components/Layout/AppLayout/Panel/resizable'

import useFullTextSearchResults from './useFullTextSearchResults'
import Row, { Loading } from './Row'

function FullTextSearchResults({
  query,
  algoliaClient,
  onEntrySelected,
  onEntries,
  highlightedEntryIndex,
  activeNoteId,
  renderEmptyPlaceholder,
  setHighlightedEntryIndex,
  organization,
}) {
  const [entries, isLoading] = useFullTextSearchResults({
    query,
    algoliaClient,
    organization,
    snippetContentLength: getSavedPanelWidth() < 400 ? 15 : 30,
  })
  React.useEffect(() => onEntries(entries), [entries, onEntries])

  if (isLoading) {
    return (
      <React.Fragment>
        <Loading />
        <Loading />
        <Loading />
      </React.Fragment>
    )
  }

  if (!entries.length) {
    return renderEmptyPlaceholder()
  }

  return (
    <React.Fragment>
      {entries.map((entry, index) => (
        <Row
          key={entry.key}
          entry={entry}
          onClick={() => onEntrySelected(entry)}
          isHighlighted={index === highlightedEntryIndex}
          isActiveNote={entry.data.id === activeNoteId}
          onMouseMove={() => setHighlightedEntryIndex(index)}
        />
      ))}
    </React.Fragment>
  )
}

FullTextSearchResults.propTypes = {
  query: PropTypes.string.isRequired,
  algoliaClient: PropTypes.object.isRequired,
  onEntrySelected: PropTypes.func.isRequired,
  onEntries: PropTypes.func.isRequired,
  highlightedEntryIndex: PropTypes.number.isRequired,
  activeNoteId: PropTypes.string,
  setHighlightedEntryIndex: PropTypes.func.isRequired,
}

export default connect(state => {
  const organization = OrganizationSelectors.getOrganization(state)
  const activeNoteId = UISelectors.getActiveNoteId(state)
  return {
    activeNoteId,
    organization,
  }
})(FullTextSearchResults)
